(function() {
  'use strict';
  
  let isProcessingGiftRemoval = false;
  let removalTimeout = null;
  
  // Funzione helper per ottenere le sections
  function getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const section = parsed.querySelector(selector);
    return section ? section.innerHTML : '';
  }
  
  // Funzione debounced per evitare chiamate multiple rapide
  function scheduleGiftCheck(cart) {
    clearTimeout(removalTimeout);
    removalTimeout = setTimeout(() => {
      removeOrphanGifts(cart);
    }, 100); // Debounce di 100ms
  }
  
  // Funzione per rimuovere i gift orfani (OTTIMIZZATA)
  async function removeOrphanGifts(cart) {
    if (isProcessingGiftRemoval) {
      console.log('[Gift Handler] Già in elaborazione, skip');
      return;
    }
    
    // Trova tutti i gift nel carrello
    const giftItems = cart.items.filter(item => 
      item.properties && item.properties._is_free_gift === 'true'
    );
    
    if (giftItems.length === 0) {
      return;
    }
    
    // Per ogni gift, verifica se il prodotto collegato esiste ancora
    const giftsToRemove = [];
    
    giftItems.forEach(gift => {
      const linkedVariantId = gift.properties._linked_to;
      
      // Cerca il prodotto principale nel carrello
      const mainProductExists = cart.items.some(item => 
        item.variant_id.toString() === linkedVariantId &&
        item.quantity > 0 &&
        (!item.properties || !item.properties._is_free_gift)
      );
      
      // Se il prodotto principale non esiste più, segna il gift per la rimozione
      if (!mainProductExists) {
        giftsToRemove.push(gift.key);
      }
    });
    
    // Rimuovi i gift orfani
    if (giftsToRemove.length > 0) {
      isProcessingGiftRemoval = true;
      console.log('[Gift Handler] Rimozione di', giftsToRemove.length, 'gift');
      
      try {
        const updates = {};
        giftsToRemove.forEach(key => {
          updates[key] = 0;
        });
        
        // OTTIMIZZAZIONE 1: Aggiorna il carrello e ottieni subito il risultato
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
        
        if (!response.ok) {
          throw new Error('Errore nella rimozione del gift');
        }
        
        const updatedCart = await response.json();
        
        // OTTIMIZZAZIONE 2: Fetch delle sezioni in parallelo (non sequenziale)
        const sectionsToLoad = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToLoad }
        }));
        
        if (sectionsToLoad.length > 0) {
          // Esegui il fetch delle sezioni in parallelo con Promise.all
          const sectionsResponse = await fetch(`${window.Shopify.routes.root}?sections=${sectionsToLoad.join(',')}`);
          const sectionsJson = await sectionsResponse.json();
          
          const cartData = {
            ...updatedCart,
            sections: {}
          };
          
          for (const [sectionId, sectionHtml] of Object.entries(sectionsJson)) {
            cartData.sections[sectionId] = getSectionInnerHTML(sectionHtml);
          }
          
          // Dispatch evento cart:change
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'gift:auto-remove',
              cart: cartData
            }
          }));
        } else {
          // Dispatch evento cart:refresh se non ci sono sezioni
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
        
        console.log('[Gift Handler] ✓ Gift rimossi');
        
      } catch (error) {
        console.error('[Gift Handler] Errore:', error);
      } finally {
        // OTTIMIZZAZIONE 3: Reset immediato del flag
        isProcessingGiftRemoval = false;
      }
    }
  }
  
  // Listener globale per cart:change (CON DEBOUNCE)
  document.documentElement.addEventListener('cart:change', async function(e) {
    // Ignora se è un evento di rimozione automatica gift
    if (e.detail.baseEvent === 'gift:auto-remove') {
      return;
    }
    
    // Verifica se è un evento di rimozione o modifica
    const relevantEvents = ['line-item:change', 'variant:remove'];
    
    if (!relevantEvents.includes(e.detail.baseEvent)) {
      return;
    }
    
    // OTTIMIZZAZIONE 4: Usa debounce per eventi multipli rapidi
    const cart = e.detail.cart;
    scheduleGiftCheck(cart);
  });
  
  // Verifica carrello al caricamento della pagina (OTTIMIZZATO)
  async function checkCartOnLoad() {
    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await cartResponse.json();
      
      // OTTIMIZZAZIONE 5: Controllo immediato senza timeout
      await removeOrphanGifts(cart);
    } catch (error) {
      console.error('[Gift Handler] Errore:', error);
    }
  }
  
  // Esegui il controllo quando la pagina è pronta
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCartOnLoad);
  } else {
    checkCartOnLoad();
  }
  
  // Esegui anche quando la pagina viene ripristinata dalla cache
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      checkCartOnLoad();
    }
  });
  
})();